export function isKeyIn<T extends object>(b: any, a: T): b is keyof T {
  return b in a
}